import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerforshirdidarshan() {



const cardData =
{
  keyword: 'Tempo Traveller for Shirdi Darshan',
  heading: 'Sanavi Travels: Tempo Traveller for Shirdi Darshan',
  headingDescription: 'Sanavi Travels offers a highly reliable, comfortable, and professionally managed Tempo Traveller for Shirdi Darshan, specially designed for devotees, families, senior citizens, corporate groups, and large pilgrimage tours visiting the holy shrine of Sai Baba. Shirdi is one of the most important spiritual destinations in India, attracting thousands of devotees daily from Pune, Mumbai, and across Maharashtra, making safe and organized group transportation essential. Our Tempo Traveller service for Shirdi Darshan is ideal for one-day trips, overnight stays, weekend darshan tours, family pilgrimages, wedding-related religious travel, and corporate spiritual outings. We provide a wide range of AC and Non-AC Tempo Travellers in multiple seating configurations such as 12 seater, 16 seater, and 20 seater, ensuring ample space, comfortable pushback seating, and sufficient luggage capacity for long-distance travel. All vehicles are regularly serviced, cleaned, and safety-checked, making them suitable for elderly passengers and long highway journeys. Our experienced and polite drivers are well-versed with Shirdi routes, darshan timings, temple entry points, parking areas, and highway conditions, ensuring timely arrival and smooth travel. With transparent pricing, flexible pickup points, customizable itineraries, and 24/7 customer support, Sanavi Travels ensures a peaceful, safe, and spiritually fulfilling Shirdi Darshan journey for every group.',

  top: 'Spiritual & Travel Experiences of Shirdi Darshan with Sanavi Travels',

  "topPlaces": [
    {
      "title": "Sai Baba Temple Darshan",
      "description": "The Sai Baba Temple in Shirdi is the primary spiritual attraction for devotees from across the country. Hiring a Tempo Traveller for Shirdi Darshan ensures group members travel together comfortably, arrive on time for darshan slots, and avoid the stress of multiple vehicles or public transport. The spacious seating and smooth ride make the journey peaceful, allowing devotees to focus on spiritual preparation rather than travel fatigue."
    },
    {
      "title": "Family Pilgrimage to Shirdi",
      "description": "Families often travel to Shirdi with children and senior citizens. Tempo Traveller hire for family Shirdi Darshan provides safe seating, easy entry and exit, and enough space for luggage and prasad items, making the journey comfortable for all age groups."
    },
    {
      "title": "Senior Citizen Darshan Tours",
      "description": "Senior citizens prefer Tempo Travellers due to higher seating comfort, stable ride quality, and experienced drivers. This makes long-distance Shirdi travel safer and less tiring for elderly devotees."
    },
    {
      "title": "Group Darshan & Bhajan Tours",
      "description": "Religious groups, bhajan mandals, and trust-organized darshan tours benefit from Tempo Traveller services that allow everyone to travel together in a disciplined and organized manner."
    },
    {
      "title": "Overnight Shirdi Darshan Trips",
      "description": "Many devotees plan overnight stays for Kakad Aarti and early morning darshan. Tempo Traveller rental supports flexible schedules, night travel safety, and comfortable rest during transit."
    },
    {
      "title": "Corporate Spiritual Trips",
      "description": "Companies and organizations often arrange spiritual trips to Shirdi for employees and management. Tempo Traveller for corporate Shirdi Darshan ensures punctual, professional, and organized travel."
    },
    {
      "title": "Outstation Highway Travel",
      "description": "Shirdi involves long highway travel from cities like Pune and Mumbai. Tempo Travellers are designed for highway comfort with stable suspension and ample legroom."
    },
    {
      "title": "Group Travel Coordination",
      "description": "Traveling in a single Tempo Traveller avoids coordination issues, convoy driving risks, and parking hassles near the temple premises."
    },
    {
      "title": "Comfort During Long Journeys",
      "description": "Long hours of travel are made comfortable with pushback seats, wide aisles, and smooth driving, especially beneficial during peak pilgrimage seasons."
    },
    {
      "title": "Peaceful & Stress-Free Pilgrimage",
      "description": "Professional drivers handle navigation, traffic, and parking, allowing devotees to focus on prayer, devotion, and spiritual fulfillment."
    }
  ],

  "services": [
    {
      "name": "Tempo Traveller for Shirdi Darshan",
      "description": "Sanavi Travels provides complete Tempo Traveller services for Shirdi Darshan, covering family pilgrimages, group tours, senior citizen travel, corporate spiritual trips, and wedding-related religious visits. Our service includes clean vehicles, experienced drivers, flexible itineraries, and reliable scheduling. The focus is on safety, comfort, and peace of mind, ensuring a spiritually fulfilling journey without travel stress."
    },
    {
      "name": "AC Tempo Traveller Shirdi",
      "description": "AC Tempo Travellers offer a cool and relaxing journey, especially suitable for long-distance Shirdi travel during summer and peak seasons, ensuring passenger comfort throughout the trip."
    },
    {
      "name": "Non AC Tempo Traveller Shirdi",
      "description": "Non AC Tempo Travellers provide a budget-friendly option for devotees looking for economical yet safe group travel to Shirdi."
    },
    {
      "name": "12 Seater Tempo Traveller Shirdi",
      "description": "12 seater Tempo Travellers are ideal for small families and close-knit groups, offering comfortable seating and flexibility for Shirdi Darshan trips."
    },
    {
      "name": "16 Seater Tempo Traveller Shirdi",
      "description": "16 seater Tempo Travellers suit medium-sized groups, balancing seating capacity, comfort, and luggage space for pilgrimage travel."
    },
    {
      "name": "20 Seater Tempo Traveller Shirdi",
      "description": "20 seater Tempo Travellers are perfect for large groups, bhajan mandals, and trust-organized darshan tours, ensuring everyone travels together safely."
    },
    {
      "name": "Luxury Tempo Traveller Shirdi",
      "description": "Luxury Tempo Travellers feature premium interiors, pushback seats, and enhanced comfort, ideal for corporate and premium pilgrimage groups."
    },
    {
      "name": "Tempo Traveller Hire for Family Shirdi",
      "description": "Family-focused Tempo Traveller services prioritize safety, comfort, and smooth travel for children and senior citizens visiting Shirdi."
    },
    {
      "name": "Tempo Traveller Hire for Group Shirdi",
      "description": "Group Tempo Traveller hire ensures organized travel, disciplined movement, and convenient scheduling for darshan tours."
    },
    {
      "name": "Tempo Traveller for Wedding Shirdi",
      "description": "Wedding-related Shirdi visits often involve family rituals and blessings. Tempo Traveller hire ensures timely and comfortable group travel."
    },
    {
      "name": "Affordable Tempo Traveller Shirdi",
      "description": "Affordable Tempo Traveller packages help groups manage travel budgets while still enjoying reliable and safe transportation."
    },
    {
      "name": "Best Tempo Traveller Service Shirdi",
      "description": "Sanavi Travels is trusted as one of the best Tempo Traveller services for Shirdi Darshan due to punctuality, safety, and service quality."
    },
    {
      "name": "Tempo Traveller with Driver Shirdi",
      "description": "All Tempo Travellers include experienced drivers familiar with Shirdi routes, temple parking zones, and darshan schedules."
    },
    {
      "name": "Tempo Traveller for Corporate Shirdi",
      "description": "Corporate Tempo Traveller services support organized spiritual outings with professional travel management."
    },
    {
      "name": "Tempo Traveller for Outstation Shirdi",
      "description": "Outstation Tempo Traveller rentals ensure comfortable long-distance travel with planned breaks and safe driving."
    }
  ],

  "tableData": [
    ["Tempo Traveller Shirdi Darshan", "Family Pilgrimage Travel"],
    ["AC Tempo Traveller", "Non AC Tempo Traveller"],
    ["12 Seater", "16 Seater"],
    ["20 Seater", "Luxury Tempo Traveller"],
    ["Group Darshan Travel", "Corporate Spiritual Trips"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Pilgrimage Drivers",
      "WhyChoosedescription": "Drivers are familiar with Shirdi temple routes and darshan timings."
    },
    {
      "WhyChooseheading": "Comfort-Oriented Vehicles",
      "WhyChoosedescription": "Pushback seats and spacious interiors ensure relaxed travel."
    },
    {
      "WhyChooseheading": "Safe Long-Distance Travel",
      "WhyChoosedescription": "Regular vehicle checks and disciplined driving practices."
    },
    {
      "WhyChooseheading": "Flexible Darshan Schedules",
      "WhyChoosedescription": "Supports one-day and overnight Shirdi trips."
    },
    {
      "WhyChooseheading": "Multiple Seating Options",
      "WhyChoosedescription": "12, 16, and 20 seater Tempo Travellers available."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear and honest pricing with no hidden charges."
    },
    {
      "WhyChooseheading": "Group-Friendly Travel",
      "WhyChoosedescription": "Entire group travels together comfortably."
    },
    {
      "WhyChooseheading": "Trusted Pilgrimage Partner",
      "WhyChoosedescription": "Sanavi Travels is trusted for Shirdi Darshan travel."
    }
  ]
};

const faqData = [
  { question: 'Do you provide Tempo Traveller for Shirdi Darshan?', answer: 'Yes, Sanavi Travels provides Tempo Traveller services for Shirdi Darshan.' },
  { question: 'Are AC Tempo Travellers available for Shirdi?', answer: 'Yes, AC and Non AC options are available.' },
  { question: 'Which seating options are available?', answer: '12 seater, 16 seater, and 20 seater Tempo Travellers are available.' },
  { question: 'Is driver included in the booking?', answer: 'Yes, all Tempo Traveller bookings include an experienced driver.' },
  { question: 'Can we plan an overnight Shirdi trip?', answer: 'Yes, one-day and overnight Shirdi Darshan trips are supported.' },
  { question: 'Is it safe for senior citizens?', answer: 'Yes, our vehicles are comfortable and suitable for senior citizens.' },
  { question: 'Do you provide corporate Shirdi trips?', answer: 'Yes, corporate spiritual trips to Shirdi are available.' },
  { question: 'Are vehicles cleaned and sanitized?', answer: 'Yes, all vehicles are regularly cleaned and maintained.' },
  { question: 'Can pickup be arranged from multiple locations?', answer: 'Yes, pickup points can be customized as per group needs.' },
  { question: 'Is highway travel comfortable in Tempo Traveller?', answer: 'Yes, Tempo Travellers are designed for long highway journeys.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Patil',
    feedback: 'Very comfortable Tempo Traveller for our Shirdi Darshan. Smooth journey and polite driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshmukh',
    feedback: 'Best Tempo Traveller service for Shirdi pilgrimage. Highly recommended.',
    rating: 5
  }
];



































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller for Shirdi Darshan - Sanavi Travels",
  "description": "Sanavi Travels offers Tempo Travellers for Shirdi Darshan for family trips, group tours, weddings, corporate travel, and outstation trips. AC and Non-AC Tempo Travellers in 12-seater, 16-seater, and 20-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Tempo Traveller for Shirdi Darshan | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Traveller for Shirdi Darshan with Sanavi Travels. AC & Non-AC 12-seater, 16-seater, and 20-seater vehicles for family trips, group tours, weddings, corporate travel, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/266.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerforshirdidarshan;